var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSymbolHashmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "35px",
    viewBox: "0 0 29 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "985BE047-69D9-4D4E-9217-B3DF2EF4C8BA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Visual-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homepage---Edit-Metrics---Alternate",
    transform: "translate(-816.000000, -756.000000)",
    fill: "#0082D3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-119",
    transform: "translate(223.000000, 208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-73",
    transform: "translate(61.000000, 78.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-68-Copy-2",
    transform: "translate(0.000000, 404.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(443.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.6445312,101 L98.5664062,90.921875 L105.667969,90.921875 L103.699219,101 L106.910156,101 L108.878906,90.921875 L116.074219,90.921875 L116.074219,87.8984375 L109.441406,87.8984375 L110.988281,79.9296875 L117.761719,79.9296875 L117.761719,76.953125 L111.574219,76.953125 L113.542969,66.734375 L110.402344,66.734375 L108.433594,76.953125 L101.285156,76.953125 L103.207031,66.734375 L99.9492188,66.734375 L98.0273438,76.953125 L91.0195312,76.953125 L91.0195312,79.9296875 L97.5117188,79.9296875 L95.9179688,87.8984375 L89.1914062,87.8984375 L89.1914062,90.921875 L95.3320312,90.921875 L93.4570312,101 L96.6445312,101 Z M106.230469,87.8984375 L99.1289062,87.8984375 L100.675781,79.9296875 L107.777344,79.9296875 L106.230469,87.8984375 Z",
    id: "symbol-hashmark"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolHashmark);
export default __webpack_public_path__ + "static/media/symbol-hashmark.878c41d2e9d3efd07d5f4eb26671d45e.svg";
export { ForwardRef as ReactComponent };